module.exports = __webpack_public_path__ + "static/media/mir.ddcfee14.svg";